import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  var Heading = []
  if (fileName == "Mis FTR Report at Product Level") {
  Heading = [['Date & Time',	'Warehouse',	'Brand','City', ' Product Code','Mrp',
    'Cross-dock location','Order Qty',	'Allocated Quantity',	'Picked Quantity',	'Packed Quantity',	'Fill Rate (%)','FTR1 (%)','FTR2 (%)','FTR (%)']]
  }
  if (fileName == "Mis FTR Detailed Report") {
  Heading = [['Date', 'Warehouse', 'Brand', 'City',	'Cross-dock Location',	'FTR 1 loss in(%)',	'FTR 2 loss in (%)',	'FTR loss in (%)']]
  }
  if (fileName == "Mis FTR Consolidated Report") {
  Heading = [['Warehouse', 'Brand', 'City', 'Cross-dock Location', 'FTR 1 loss in(%)',	'FTR 2 loss in (%)',	'FTR loss in (%)']]
  }
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}
class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchDispatchData = this.fetchDispatchData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,
      from_date: "",
      to_date: "",
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      warehouse_code :"",
      brand_code :"",
      warehouseData:"",
      clientData:"",
      city : "",
      cityData:"",
      product_view: true,
      consolidated_view: false,
      detailed_view: false,
      tableRowsConsolidatedMap: [], 
      tableRowsDetailedMap: [], 
      tableRowsProductMap: [], 
      showProductDispatchData: true, 
      showDetailedDispatchData: false,
      showConsolidatedDispatchData: false,
      filter_model : false,
      filtered_orderData : [],
      reports_type : "Mis FTR Report at Product Level"
    };
  }

  handleChange = (evt) => {
    if (evt.target.value == "product_view") {
      this.setState({ product_view: true, consolidated_view: false,detailed_view: false, tableRowsConsolidatedMap: [], tableRowsDetailedMap: [], tableRowsProductMap: [], showProductDispatchData: true, showDetailedDispatchData: false,showConsolidatedDispatchData: false, reports_type : "Mis FTR Report at Product Level"})
    }
    if (evt.target.value == "detailed_view") {
      this.setState({ detailed_view: true, consolidated_view: false, product_view: false, tableRowsConsolidatedMap: [], tableRowsDetailedMap: [], tableRowsProductMap: [], showProductDispatchData: false, showDetailedDispatchData: true,showConsolidatedDispatchData: false, reports_type : "Mis FTR Detailed Report" })
    }
    else if (evt.target.value == "consolidated_view") {
      this.setState({ detailed_view: false, consolidated_view: true, product_view: false, tableRowsConsolidatedMap: [], tableRowsDetailedMap: [], tableRowsProductMap: [], showProductDispatchData: false, showDetailedDispatchData: false,showConsolidatedDispatchData: true, reports_type : "Mis FTR Consolidated Report" })
    }

  }
  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
    this.fetchWarehouseData();
    this.fetchBrandData();
    this.fetchCityData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }
  }
  ToDateChange = date => {
    this.setState({
      to_date: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",
      })
      to_Date_val = ""
    }
  }
  toggleOK = () =>  {
    this.setState({
      filter_model : false,
    });}
  oncityChange = (evt) =>{
    this.setState({
      city : evt.target.value
    })
  }
  onwarehouseChange = (evt) => {
    this.setState({
      warehouse_code: evt.target.value
    })
  }
  onBrandChange = (evt) => {
    this.setState({
      brand_code: evt.target.value
    })
  }
  fetchCityData = () =>{
    const payload = {
    };
    API.post('/product/product_master/v1/city/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          cityData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }
  fetchWarehouseData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }
  fetchDispatchData() {
    
    this.setState({
      loading_overlay: true,
      loading: true,
    })
    if (!(this.state.subgroup) && !(this.state.order) && !(this.state.sku) && !(From_Date_val) && !(to_Date_val)) {
      this.setState({
        filter_model :true,
        loading: false,
        loading_overlay: false
      })
    }
    else{
        var view_type = ""
        if (this.state.detailed_view == true) {
          view_type = "detailed_view"
        }
        else if (this.state.consolidated_view == true) {
          view_type = "consolidated_view"
        }
        else if (this.state.product_view == true) {
          view_type = "product_view"
        }
        const payload = {
          from_date: From_Date_val,
          to_date: to_Date_val,
          brand_code : this.state.brand_code,
          warehouse_code : this.state.warehouse_code,
          city_code : this.state.city,
          view_type : view_type,
        };
        API.post('/mis/new_fill_rate_report', { param: payload })
          .then(response => response.data)
          .then(data => {
          
            // this.setState({ tableRows: this.assemblePosts(data.data)})
          
          if (data.data_type == "detailed_view") {
            this.setState({
              tableRowsDetailedMap: this.assembleDetailedData(data.data),
              showDetailedDispatchData: true,
              dispatch_status: false,
              loading: false,
            });
          }
          if (data.data_type == "consolidated_view") {
            this.setState({
              tableRowsConsolidatedMap: this.assembleConsolidatedData(data.data),
              showConsolidatedDispatchData: true,
              dispatch_status: false,
              loading: false,
            });
          }
          if (data.data_type == "product_view") {
            this.setState({
              tableRowsProductMap: this.assembleProductData(data.data),
              showProductDispatchData: true,
              dispatch_status: false,
              loading: false,
            });
          }
        })
        .catch(function (error) { })
          .then(async () => {
            this.setState({  isLoading: false ,loading_overlay: false})
          });
  };}
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }       
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );     
        this.setState({
          filtered_orderData: value,
        });
      }
    };
  
  assembleProductData = (data) => {

    let posts = data.map((post) => {
      return (      
        {
          date_time : post.date_time,
          warehouse: post.warehouse,
          brand : post.brand,
          city : post.city,
          product_code : post.product_code,
          mrp : post.mrp,
          cross_dock_loc : post. cross_dock_loc,
          order_qty : post.order_qty,
          allocated_qty : post.allocated_qty,
          picked_qty : post.picked_qty,
          packed_qty :post.packed_qty,
          fill_rate : post.fill_rate,   
          // ftr0 : post.ftr0,
          ftr1 : post.ftr1,
          ftr2 : post.ftr2,
          ftr  : post.ftr,
        }
      )
    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }
  assembleDetailedData = (data) => {

    let posts = data.map((post) => {
      return (      
        {
          date : post.date,
          warehouse: post.warehouse,
          brand : post.brand,
          city : post.city,
          cross_dock : post.cross_dock_loc,
          ftr1 : post.ftr1,
          ftr2 : post.ftr2,
          ftr : post.ftr,
          
        }
      )
    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }
  assembleConsolidatedData = (data) => {

    let posts = data.map((post) => {
      return (      
        {
          warehouse: post.warehouse,
          brand : post.brand,
          city : post.city,
          cross_dock : post.cross_dock_loc,
          ftr1 : post.ftr1,
          ftr2 : post.ftr2,
          ftr : post.ftr,
        }
      )
    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }
  render() {

    const  tableRowsProductMap = {
      columns: [    
        {
          label: 'Date & Time',
          field: 'date_time',
          sort: 'asc',
          width: 140,
        },
        {
          label: "Warehouse",
          field: "warehouse",
          width: 140,
        },    
        {
          label: "Brand",
          field: "brand",
          width: 130,
        },
        {
          label: "City",
          field: "city",
          width: 120,
        },
        {
          label: "Product Code",
          field: "product_code",
          width: 150,
        },
        {
          label: "Mrp",
          field: "mrp",
          width: 130,
        },
        {
          label: "Cross-dock location",
          field: "cross_dock_loc",
          width: 170,
        },
        {
          label: "Order Qty",
          field: "order_qty",
          width: 130,
        },
        {
          label: "Allocated Quantity",
          field: "allocated_qty",
          width: 120,
        },
        {
          label: "Picked Quantity",
          field: "picked_qty",
          width: 120,
        },
        {
          label: "Packed Quantity",
          field: "packed_qty",
          width: 120,
        },
        {
          label: "Fill Rate (%)",
          field: "fill_rate",
          width: 120,
        },
        
        // {
        //   label: "FTR0 in %",
        //   field: "ftr0",
        //   width: 100,
        // },     
        {
          label: "FTR1 in %",
          field: "ftr1",
          width: 100,
        },
        {
          label: "FTR2 in %",
          field: "ftr2",
          width: 100,
        },
        {
          label: "FTR in %",
          field: "ftr",
          width: 100,
        },
        
      ],

      rows: this.state.tableRowsProductMap,

    }
    const  tableRowsDetailedMap = {
      columns: [    
        {
          label: 'Date',
          field: 'date',
          sort: 'asc',
          width: 140,
        },
        {
          label: "Warehouse",
          field: "warehouse",
          width: 140,
        },    
        {
          label: "Brand",
          field: "brand",
          width: 130,
        },
        {
          label: "City",
          field: "city",
          width: 140,
        },
        {
          label: "Cross-dock Location",
          field: "cross_dock",
          width: 170,
        },
        {
          label: "FTR 1 loss in (%)",
          field: "ftr1",
          width: 130,
        },
        {
          label: "FTR 2 loss in (%)",
          field: "ftr2",
          width: 130,
        },
        {
          label: "FTR loss in (%)",
          field: "ftr",
          width: 130,
        },
        
        
      ],

      rows: this.state.tableRowsDetailedMap,

    }
    const  tableRowsConsolidatedMap = {
      columns: [    
        {
          label: "Warehouse",
          field: "warehouse",
          width: 140,
        },    
        {
          label: "Brand",
          field: "brand",
          width: 130,
        },
        {
          label: "City",
          field: "city",
          width: 140,
        },
        {
          label: "Cross-dock Location1",
          field: "cross_dock",
          width: 170,
        },
        {
          label: "FTR 1 loss in (%)",
          field: "ftr1",
          width: 130,
        },
        {
          label: "FTR 2 loss in (%)",
          field: "ftr2",
          width: 130,
        },
        {
          label: "FTR loss in (%)",
          field: "ftr",
          width: 130,
        },
        
      ],

      rows: this.state.tableRowsConsolidatedMap,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <CardBody style={{ paddingTop: 22, height: 100, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >
          <div
                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 190 }}
                    onChange={this.handleChange}
                  // name="year"               
                  >
                    <option value="detailed_view">Select View Type</option>
                    <option value="product_view">Product </option>
                    <option value="detailed_view">Detailed View </option>
                    <option value="consolidated_view">Consolidated View </option>
                  </select>
                </div>
              </div>
            <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

            {this.state.product_view &&
              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="Dispatch Date"
                format='yyyy-MM-dd'

              />
            }
            {(this.state.detailed_view || this.state.consolidated_view) &&
              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="Dispatch Date From"
                format='yyyy-MM-dd'

              />
            }

            </div>
            {(this.state.detailed_view || this.state.consolidated_view) &&
            <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="Dispatch Date To"
              />
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }

            </div>
  }
            <div
                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5, }}
              >
                <div
                  className="form__form-group-field"

                >
              <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.oncityChange}
                  >
                    <option value="">Select City</option>
                    {
                      this.state.cityData.length > 0 &&
                      this.state.cityData.map((cityData) => {
                        return (
                          <option value={cityData.name}>{cityData.name} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>
              <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13}}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
              </div>
              <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                </div>
                

            <div style={{ width: '9%', marginBottom: '0px', marginLeft: "50px", float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={() => this.fetchDispatchData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
              </ButtonToolbar>
            </div>
            <div style={{ width: '6%', marginBottom: '0px', float: 'left' }}>
              <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                // onClick={this.downloadReport}
              >
                <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, this.state.reports_type)} />
              </Button>
            </div>
          </form>
          </CardBody>
          {
            this.state.showProductDispatchData && (
              <CardBody style={{ marginTop: 5,paddingTop :0 }}>            
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={tableRowsProductMap}
                  style={{ textAlign: "center",paddingTop:0 }}
                />
                
              </CardBody>

            )}
            {
            this.state.showDetailedDispatchData && (
              <CardBody style={{ marginTop: 5, paddingTop :0 }}>            
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={tableRowsDetailedMap}
                  // style={{ textAlign: "center" }}
                />
                
              </CardBody>

            )}
            {
            this.state.showConsolidatedDispatchData && (
              <CardBody style={{ marginTop: 5, paddingTop :0 }}>            
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={tableRowsConsolidatedMap}
                  // style={{ textAlign: "center" }}
                />
                
              </CardBody>

            )}

        </Card>
        <Modal isOpen={this.state.filter_model} >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              // onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "red" }}
            />
            <h4> One of the Filter is Mandatory</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));